export default __webpack_public_path__ + "static/media/zero-state.8c2adace.svg";